import { Symbology } from "@scandit/web-datacapture-barcode";

// Use a larger scanning area on mobile devices to ensure QR codes have sufficient resolution
// QR codes require more pixels than linear barcodes to be properly detected
export const getScanningArea = () => {
  const isMobile = window.innerWidth <= 768;

  if (isMobile) {
    return {
      x: 0.05,
      y: 0.25,
      width: 0.9,
      height: 0.5,
    };
  }

  return {
    x: 0.15,
    y: 0.35,
    width: 0.7,
    height: 0.3,
  };
};

export const scanningArea = getScanningArea();

export const enabledSymbologies = [
  Symbology.Codabar,
  Symbology.Code11,
  Symbology.Code25,
  Symbology.Code128,
  Symbology.Code39,
  Symbology.QR,
  Symbology.DataMatrix,
  Symbology.EAN13UPCA,
  Symbology.EAN8,
  Symbology.UPCE,
  Symbology.InterleavedTwoOfFive,
];
